import ExtendableError from 'es6-error';
import { selectIsAuthenticatedUser } from '@gandi/authentication';
import { selectPricingInfos } from '@gandi/billing';
import { createCart, getLastCart, setCartUUID, resetCart, deleteCart, removeProduct } from '../modules/actions';
import { selectCartIsActive, selectCartUUID, selectTotalProducts, selectHasDomainCorporateProducts, selectProductsByType } from '../modules/selectors';
class CartError extends ExtendableError {
  constructor(message, response) {
    super(message);
    this.response = response;
    this.apiErrors = response && response.data && response.data.errors ? response.data.errors : [];
  }
  hasExpectedErrors(apiFieldnames) {
    return (this.apiErrors || []).filter(err => apiFieldnames.indexOf(err.name) >= 0).length > 0;
  }
  toFormErrors(formToApiMap = {}) {
    const apiToFormMap = Object.keys(formToApiMap).reduce((acc, key) => ({
      ...acc,
      [formToApiMap[key]]: key
    }), {});
    return this.apiErrors.reduce((acc, error) => {
      const translatedKey = apiToFormMap[error.name] || error.name;
      return {
        ...acc,
        [translatedKey]: error.description
      };
    }, {});
  }
}
const ensureCartReady = cartId => (dispatch, getState) => Promise.resolve().then(() => {
  const currentCartId = selectCartUUID(getState());
  if (currentCartId) return null;
  if (!selectIsAuthenticatedUser(getState())) return null;
  if (!cartId && !currentCartId) {
    return dispatch(getLastCart());
  }
  return dispatch(setCartUUID(cartId));
}).then(() => {
  const currentCartId = selectCartUUID(getState());
  if (currentCartId) return null;
  if (!cartId && !currentCartId) {
    const {
      country,
      currency
    } = selectPricingInfos(getState());
    return dispatch(createCart({
      country,
      currency
    }));
  }
  return dispatch(setCartUUID(cartId));
}).then(() => {
  const currentCartId = selectCartUUID(getState());
  if (!currentCartId) throw new CartError('No cart available.');
  const isActive = selectCartIsActive(getState());
  if (!isActive) throw new CartError(`Cart ${currentCartId} is inactive.`);
});
export const ensureWeHaveACart = cartId => dispatch => Promise.resolve().then(() => dispatch(ensureCartReady(cartId))).catch(() => dispatch(ensureCartReady()));
export const deleteCartIfEmpty = () => (dispatch, getState) => {
  const shouldDelete = selectTotalProducts(getState()) === 0;
  return shouldDelete && dispatch(deleteCart()).then(() => dispatch(resetCart()));
};
export const cleanCorporateProducts = () => (dispatch, getState) => {
  const hasCorporateProducts = selectHasDomainCorporateProducts(getState());
  const corporateCreateProductId = selectProductsByType(getState(), {
    productType: 'corporate'
  }).find(product => product.process === 'create')?.id;
  return !hasCorporateProducts && !!corporateCreateProductId && dispatch(removeProduct(corporateCreateProductId));
};
export function cleanMarketplaceProducts(deletedProducts) {
  return (dispatch, getState) => {
    const deletedDomains = deletedProducts.filter(product => product.productType === 'domain');
    const marketplaceProductsToDelete = selectProductsByType(getState(), {
      productType: 'marketplace'
    }).filter(service => service.payload.fqdn && deletedDomains.find(product => product.payload.fqdn && [product.payload.fqdn, product.identifier].includes(service.payload.fqdn)));
    return Promise.all(marketplaceProductsToDelete.map(service => dispatch(removeProduct(service.id))));
  };
}